import BottomAppBar from './app-bar';
export default BottomAppBar;